import { render, staticRenderFns } from "./newHome2.vue?vue&type=template&id=559bb4fe&scoped=true&"
import script from "./newHome2.vue?vue&type=script&lang=js&"
export * from "./newHome2.vue?vue&type=script&lang=js&"
import style0 from "./newHome2.vue?vue&type=style&index=0&lang=less&"
import style1 from "./newHome2.vue?vue&type=style&index=1&id=559bb4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559bb4fe",
  null
  
)

export default component.exports